import { AIPrompt } from '@src/types.ts/ai_prompts';
import { RootStore } from '@src/stores-v2/RootStore';
import { AIFlow } from '@src/aiFlow/AIFlow';

export async function enrichAIFlowWithImpactScore(
  aiFlow: AIFlow,
  rootStore: RootStore,
): Promise<{ prompt: AIPrompt | undefined }> {
  const prompt = await getImpactScorePrompt(rootStore);

  addToAIFlowContext(aiFlow, prompt);

  addImpactScoreToStepsConfigIfUsed(aiFlow, prompt);

  return { prompt };
}

function addToAIFlowContext(aiFlow: AIFlow, prompt: AIPrompt | undefined) {
  if (!aiFlow.context) {
    aiFlow.context = {};
  }
  aiFlow.context['AIPrompt.impactScore'] = prompt?.description;
}

async function getImpactScorePrompt(
  rootStore: RootStore,
): Promise<AIPrompt | undefined> {
  try {
    return await rootStore.datoClientStore.aiPromptRepository.getPromptByTitle(
      'Impact Score',
    );
  } catch (err) {
    console.error('Error while fetching impact score prompt', err);
  }
  return undefined;
}

function addImpactScoreToStepsConfigIfUsed(
  aiFlow: AIFlow,
  prompt: AIPrompt | undefined,
): void {
  if (!prompt?.description) {
    return;
  }
  for (const step of aiFlow.steps) {
    if (step.userPromptTemplate?.includes('{{AIPrompt.impactScore}}')) {
      step.config.impactScoreKeys = prompt.promptFields.map((f) => f.name);
    }
  }
}
